//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'user-info-page',
  data() {
    return {
      form: {
        card_password: '',
        card_id: ''
      }
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
  },
  methods: {
    submit () {
      const body = Object.assign({}, this.form)
      if (!this.form.card_password) {
        return Toast({
          message: '請填寫卡密',
          duration: 3000
        })
      }
      if (!this.form.card_id) {
        return Toast({
          message: '請填寫卡號',
          duration: 3000
        })
      }
      this.$store.httpDispatch({})('chargeCard', body).then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.$store.httpDispatch({})('getUserInfo').then((res) => {
            const { code, data, msg } = res.data
            if (code === 0) {
              Toast({
                message: '充值成功',
                duration: 3000
              })
              this.$store.dispatch('setUser', { user: data.user })
              this.$router.push('/')
            } else if (code === 4040005) {
              return Toast({
                message: '卡號或者密碼錯誤',
                duration: 3000
              })
            } else {
              console.log()
              return Toast({
                message: msg,
                duration: 3000
              })

            }
          }).catch((err) => {
            console.log(err)
              return Toast({
                message: msg,
                duration: 3000
              })
          })
        }
      }).catch((err) => {
        return Toast({
          message: err.data && err.data.msg,
          duration: 3000
        })
      })
    }
  }
}
